import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appXIModalContent]',
  standalone: false,
})
export class XiModalContentDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
